import React, { useState } from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

const DividendTracker = ({ dividends, onReinvest }) => {
  const [tab, setTab] = useState("upcoming");
  const filtered = dividends?.filter(d => tab === "upcoming" ? d?.status === "upcoming" : d?.status === "paid");

  return (
    <div className="rounded-xl border border-border overflow-hidden" style={{ background: "var(--color-card)" }}>
      <div className="flex items-center justify-between px-4 md:px-6 py-4 border-b border-border">
        <div className="flex items-center gap-2">
          <Icon name="Coins" size={18} color="var(--color-success)" />
          <h3 className="font-heading text-base font-semibold text-foreground">Dividends</h3>
        </div>
        <div className="flex items-center gap-1 p-1 rounded-lg" style={{ background: "var(--color-muted)" }}>
          {["upcoming", "history"]?.map(t => (
            <button key={t} onClick={() => setTab(t)} className={`px-3 py-1 rounded-md font-caption text-xs capitalize transition-all duration-200 ${tab === t ? "text-primary-foreground" : "text-muted-foreground hover:text-foreground"}`} style={tab === t ? { background: "var(--color-primary)", color: "var(--color-primary-foreground)" } : {}}>
              {t}
            </button>
          ))}
        </div>
      </div>
      <div className="divide-y divide-border/50">
        {filtered?.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-8 text-muted-foreground">
            <Icon name="Coins" size={28} color="var(--color-muted-foreground)" />
            <p className="font-caption text-sm mt-2">No {tab} dividends</p>
          </div>
        ) : filtered?.map(d => (
          <div key={d?.id} className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-4">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-md flex items-center justify-center text-xs font-heading font-bold" style={{ background: "rgba(16,185,129,0.15)", color: "var(--color-success)" }}>
                {d?.ticker?.slice(0, 2)}
              </div>
              <div>
                <div className="font-heading text-sm font-semibold text-foreground">{d?.ticker}</div>
                <div className="font-caption text-xs text-muted-foreground">{d?.payDate} · {d?.qty} shares · ${d?.perShare?.toFixed(4)}/share</div>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="text-right">
                <div className="font-data text-sm font-semibold text-green-400">${d?.total?.toFixed(2)}</div>
                <div className="font-caption text-xs text-muted-foreground">Yield: {d?.yield?.toFixed(2)}%</div>
              </div>
              {d?.status === "upcoming" && (
                <Button variant="outline" size="xs" iconName="RefreshCw" iconPosition="left" onClick={() => onReinvest(d)}>Reinvest</Button>
              )}
              {d?.status === "paid" && (
                <span className="font-caption text-xs px-2 py-1 rounded" style={{ background: "rgba(16,185,129,0.15)", color: "var(--color-success)" }}>Paid</span>
              )}
            </div>
          </div>
        ))}
      </div>
      {tab === "history" && filtered?.length > 0 && (
        <div className="px-4 md:px-6 py-3 border-t border-border flex items-center justify-between">
          <span className="font-caption text-xs text-muted-foreground">Total received this year</span>
          <span className="font-data text-sm font-semibold text-green-400">${filtered?.reduce((s, d) => s + d?.total, 0)?.toFixed(2)}</span>
        </div>
      )}
    </div>
  );
};

export default DividendTracker;